import { Environment } from '@shared/interfaces/environment';

const URL_ADMIN_GATEWAY = 'https://admingateway-dev.inclub.world';

export const environment: Environment = {
	URL_API: 'https://usersapi.inclub.world',
	URL_WEB: 'https://dev.inclub.world/',
	LOGIN_USER_CLIENT: 'client',
	LOGIN_USER_SECRET: 'secret',
	CODE_CHALLENGE: 'meWMSrkRBnMbd5RRseIVwuFGFOU6xwHi0_LgQyCOd1A',
	CODE_CHALLENGE_METHOD: 'S256',
	TOKEN_PAYPAL: 'AY9d5jrHkZwPllAZSM9VqWR-6Na5CZd0W7FX0YfnUJ7P1vCkY6oI6YeikymWbwSWsRn_FAlngtku095k',
	CLIENT_ID: 'floofle-client',
	CLIENT_SECRET: 'secret',
	URL_AUTH_SERVER: 'oauth-dev.inclub.world',
	LOGIN_URL: '/oauth2/authorization/backoffice-gateway',
	SHOW_IMAGES_COMPONENT: false,
	URL_IMG: 'https://s3.us-east-2.amazonaws.com/backoffice.documents/bo-imagenes/',
	LOCAL_LOGIN: false,
	URL_ADMIN: `${URL_ADMIN_GATEWAY}/panel-admin/api`,
	URL_ADMIN_GATEWAY: URL_ADMIN_GATEWAY,
	URL_API_VALIDA_SPONSOR: `${URL_ADMIN_GATEWAY}/panel-admin/api/user/exists`,
	URL_GATEWAY: 'https://opengateway-dev.inclub.world/api/v1',
	URL_ACADEMY: 'https://dev.academy.inclub.world/',
	CHATBOT_API_BASE_URL: 'https://chatbotapi-dev.inclub.world/api/v2.0/chatbot',
	CHATBOT_WS_URL: 'wss://chatbotws-dev.inclub.world/api/v1.0/ws/user/history-user',
	CHATBOT_API_KEY: 'ASCSEFVCMASLFKEOALSADC!$DAS',
	URL_ACADEMY_API: 'https://gatewayapi-dev.academy.inclub.world',
	FIREBASE_CONFIG: {
		apiKey: 'AIzaSyCfA89VZxAq6_fXVgBVJ5lub5QdJcg80wU',
		authDomain: 'inclub-web.firebaseapp.com',
		projectId: 'inclub-web',
		storageBucket: 'inclub-web.firebasestorage.app',
		messagingSenderId: '865870667235',
		appId: '1:865870667235:web:6f95db459ec82bad20d4d6',
		measurementId: 'G-WHYBEPG8MR',
	},
};

